import CustomFieldPanel from './CustomFieldPanel';

import PlusIcon from '@svgIcons/plus.svg';

import * as S from './style';

import CustomFieldIcon from '@svgIcons/datastream/custom-field.svg';
import EditIcon from '@svgIcons/edit.svg';
import CloseIcon from '@svgIcons/close.svg';
import { FLEX_VERTICAL_CENTER_DIV } from '@/styles/common.styled.component';
import { isValueExist } from '@/utils/utils';
import { DIRECTIVE_CLAMP } from '@/styles/common.styled';
// import { ExportDataService } from '@/services';
import { mapMutations } from 'vuex';
import { useSecondPanel } from '@/composable/useSecondPanel';

export default {
    name: 'CustomField',
    setup() {
        const { isSecondPanelOpen, closeSecondPanel, toggleSecondPanel } =
            useSecondPanel({ key: 'customField' });

        return { isSecondPanelOpen, closeSecondPanel, toggleSecondPanel };
    },
    props: {
        customFields: {
            type: Array,
            default() {
                return [];
            },
        },
        categoryLocaleMap: {
            type: Object,
            default() {
                return {};
            },
        },
        availableMetricList: {
            type: Array,
            default() {
                return [];
            },
        },
        availableBreakdownList: {
            type: Array,
            default() {
                return [];
            },
        },
        translator: {
            type: Function,
        },
        isMarketing: {
            type: Boolean,
        },
        streamType: {
            type: String,
        },
    },
    data() {
        return {
            selectedField: null,
        };
    },
    methods: {
        ...mapMutations('view', ['setNotiMsgs']),
        renderCustomFieldPanel() {
            const {
                isSecondPanelOpen,
                customFields,
                selectedField,
                categoryLocaleMap,
                availableMetricList,
                availableBreakdownList,
                translator,
                isMarketing,
                streamType,
            } = this;
            if (!isSecondPanelOpen) return null;

            const props = {
                attrs: {
                    active: isSecondPanelOpen,
                    customFields,
                    selectedField,
                    categoryLocaleMap,
                    availableMetricList,
                    availableBreakdownList: availableBreakdownList,
                    translator,
                    isMarketing,
                    streamType,
                },
                on: {
                    activeChange: (v) => (v ? null : this.closeSecondPanel()),
                    setCustomFields: (v) => this.$emit('setCustomFields', v),
                    setHasCustomFieldChanged: (v) =>
                        this.$emit('setHasCustomFieldChanged', v),
                    setSelectedField: (v) => (this.selectedField = v),
                },
            };
            return <CustomFieldPanel {...props} />;
        },
        async deleteCustomField(field) {
            const { id } = field;

            try {
                // await ExportDataService.deleteCustomField(id);

                this.$emit(
                    'setCustomFields',
                    R.reject(
                        ({ id: listId }) => String(listId) === String(id),
                        this.customFields
                    )
                );

                this.$emit('setHasCustomFieldChanged', true);

                if (this.selectedField?.id === id) {
                    this.selectedField = null;
                }

                this.setNotiMsgs([
                    {
                        type: 'SUCCESS',
                        title: this.$t(
                            'EXPORT_DATA.custom_field_delete_success_message'
                        ),
                    },
                ]);
            } catch (error) {
                const { code, message } = error.response?.data || {};

                const refinedMessage = this.translateOr(
                    `EXPORT_DATA.custom_field_error_${code}`,
                    message
                );

                this.setNotiMsgs([
                    {
                        type: 'FAIL',
                        title: refinedMessage,
                    },
                ]);
            }
        },
        renderCustomFields() {
            if (!isValueExist(this.customFields)) {
                return (
                    <S.CustomFieldPlaceholder
                        onClick={() => this.toggleSecondPanel()}
                    >
                        {this.$t('NEW_DASHBOARD.list_empty_dimensions')}
                    </S.CustomFieldPlaceholder>
                );
            }

            return this.customFields.map((field) => {
                const { name, id } = field;
                return (
                    <S.ItemBox key={id}>
                        <div {...DIRECTIVE_CLAMP} class={['item-text']}>
                            {name}
                        </div>

                        <EditIcon
                            v-view-box
                            class="edit-icon"
                            onClick={() => {
                                this.selectedField = field;
                                this.toggleSecondPanel();
                            }}
                        />
                        <CloseIcon
                            v-view-box
                            class="close-icon"
                            onClick={() => {
                                return this.dialog({
                                    text: this.$t(
                                        'EXPORT_DATA.custom_field_delete_message'
                                    ),
                                    confirmText: this.$t('COMMON.delete'),
                                    confirmType: 'danger',
                                    confirmCb: () =>
                                        this.deleteCustomField(field),
                                });
                            }}
                        />
                    </S.ItemBox>
                );
            });
        },
    },
    render() {
        return (
            <S.TableWrapper>
                <S.TableTitleWrapper
                    cursor="pointer"
                    onClick={() => {
                        this.selectedField = null;
                        this.toggleSecondPanel();
                    }}
                >
                    <S.TableTitleWithIconWrapper>
                        <FLEX_VERTICAL_CENTER_DIV>
                            <CustomFieldIcon />
                            {this.$t('EXPORT_DATA.custom_field_title')}
                        </FLEX_VERTICAL_CENTER_DIV>
                        <PlusIcon class="plus-icon" v-view-box />
                    </S.TableTitleWithIconWrapper>
                </S.TableTitleWrapper>
                <S.CustomFieldsItemWrapper>
                    {this.renderCustomFields()}
                </S.CustomFieldsItemWrapper>
                {this.renderCustomFieldPanel()}
            </S.TableWrapper>
        );
    },
};
